export default class RemoveApiToken {
  constructor(context) {
    this.context = context;
  }

  run(id) {
    this.context.stores.apiTokens.remove(id);
    this.context.gateways.apiToken.remove(this.currentAgentId, id);
  }

  get currentAgentId() {
    return this.context.stores.currentAgent.get().id;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/api_tokens/remove_api_token.js